module.exports = __webpack_public_path__ + "media/proctitis.ae1a0478.wav";